import { validateRequired } from 'hb-react/shared/utils/validators/required';

export const validateLocation = ({ required, value }) => {
  let error;

  if (required) {
    error = validateRequired(value);
  }

  return error;
};
